import React from 'react';
import { cn } from 'lib/utils';

export interface PageContainerProps {
    children: React.ReactNode;
    className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, className = '' }) => {
    return (
        <div
            className={cn(
                'mx-auto w-full max-w-[1440px] px-6 py-6 md:px-8 md:py-8 text-foreground',
                className
            )}
        >
            {children}
        </div>
    );
};

export default PageContainer;
